import { Stack, Text } from "@chakra-ui/react";

export const data = [
    {
        key: 'import',
        label: "Enter your website to get started",
        description: (
            <Stack spacing={5}>
                <Text>Generate your visual sitemap by crawling your website, importing an existing XML sitemap, or uploading a CSV file.
                </Text>
                <Text>We'll keep a record of your import history for you, if you need to create another sitemap.</Text>
            </Stack>
        ),
        imgSrc: `/images/generator-steps/import.webp`
    },
    {
        key: 'progress',
        label: "Track progress and create your sitemap",
        description: (
            <Stack spacing={5}>
                <Text>Once the import is completed, make any necessary changes to your pages, and create your sitemap.
                </Text>
                <Text><strong>Tip:</strong> You can create multiple visual sitemaps off a single import!</Text>
            </Stack>
        ),
        imgSrc: `/images/generator-steps/progress.webp`
    },
    {
        key: 'sitemap',
        label: "Start planning, editing & collaborating",
        description: (
            <Stack spacing={5}>
                <Text>Once your sitemap has been created, you'll be dropped into our collaborative real-time editor.
                </Text>
                <Text>Use our free drag and drop sitemap editor to plan your website architecture, content, and user flows with your whole team</Text>
            </Stack>
        ),
        imgSrc: `/images/generator-steps/sitemap.webp`
    }
]